<template>
  <div :class="$style.container">
    <Icon
      v-if="srcIcon"
      :class="$style.osIcon"
      :icon="srcIcon"
      :scale="2"
    />
    <span
      v-else
      :class="$style.dataNotAvailable"
    >
      {{ dataNotAvailable }}
    </span>
    <div
      v-if="showLabel"
      :class="$style.label"
    >
      <span v-if="system.os || system.version">
        {{ deviceOS }}
      </span>
      <div>
        <StatusBadge
          v-for="infoPill in infoPills"
          :key="infoPill.text"
          :class="$style.infoPill"
          :status="infoPill.status"
          :text="infoPill.text"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { Icon, StatusBadge } from '@jumpcloud/ui-components';
import Constants from 'client/util/Constants';
import SystemMixin from 'client/store/mixins/SystemMixin';

export default {
  name: 'SystemOSIcon',

  components: {
    Icon,
    StatusBadge,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      dataNotAvailable: Constants.dataNotAvailable,
    };
  },

  computed: {
    deviceOS() {
      return this.isWindows && this.system.osVersionDetail
        ? `${this.system.os || ''} ${this.system.version || ''} (${this.system.osVersionDetail.patch}.${this.system.osVersionDetail.revision})`
        : `${this.system.os || ''} ${this.system.version || ''}`;
    },

    infoPills() {
      return [
        {
          status: 'success',
          text: 'MDM',
          showPill: this.isMdmEnrolled,
        },
        {
          status: 'informational',
          text: 'AD Joined',
          showPill: this.isWindowsDomainJoined,
        },
      ].filter(pill => pill.showPill);
    },

    isAndroid() {
      return SystemMixin.isAndroid(this.system);
    },

    isIOS() {
      return SystemMixin.isIOS(this.system);
    },

    isLinux() {
      return SystemMixin.isLinux(this.system);
    },

    isMacOS() {
      return SystemMixin.isMacOS(this.system);
    },

    isMdmEnrolled() {
      return SystemMixin.isSystemMdmEnrolled(this.system);
    },

    isUniversalPolicy() {
      return SystemMixin.isUniversalPolicy(this.system);
    },

    isWindows() {
      return SystemMixin.isWindows(this.system);
    },

    isWindowsDomainJoined() {
      return SystemMixin.isWindowsDeviceDomainJoined(this.system);
    },

    srcIcon() {
      const srcs = {
        apple: this.isIOS || this.isMacOS,
        linux: this.isLinux,
        devices: this.isUniversalPolicy,
        windows: this.isWindows,
        android: this.isAndroid,
      };

      const [src] = Object.entries(srcs).find((valueSrc) => valueSrc[1]) || [];

      return src;
    },

    system() {
      return this.item.system || this.item;
    },
  },
};
</script>

<style scoped module>
@value iconSize: 35px;
@value (greyDark1, greyLight1, greyLight3) from '~css/colors.css';

.container {
  white-space: nowrap;
}

.dataNotAvailable,
.icon {
  display: inline-block;
  height: iconSize;
  vertical-align: top;
  width: iconSize;
}

.dataNotAvailable {
  line-height: iconSize;
  text-align: center;
}

.label {
  align-items: flex-start;
  display: inline-flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  margin-left: 2.5rem;
  min-height: iconSize;
}

.infoPill {
  margin-right: 8px;
}

.osIcon {
  margin-top: 0.25rem;
  position: absolute !important;
}
</style>
